import React from 'react';
import PropTypes from 'prop-types';

import Divider from '@urbanmassage/component-library/lib/Divider/Divider';

import GiftsHeader from './GiftsHeader';
import GiftsSelectCity from './GiftsSelectCity';
import GiftsSelectType from './GiftsSelectType';
import GiftsDeliveryOptions from './GiftsDeliveryOptions';
import GiftsMessage from './GiftsMessage';
import GiftCardUpgrade from './GiftCardUpgrade';

//TODO: Remove this when removing GIFT_VOUCHERS_CONFIG -> UD-639_Gift-vouchers-config
import GiftsSelectTypeOld from './GiftsSelectTypeOld';

//TODO: Remove this when removing GIFT_MAX_CHARS -> UD-615_Gifts-max-characters
import GiftsMessageOld from './GiftsMessageOld';

//TODO: Remove this when removing GIFT_VOUCHERS_CONFIG -> UD-639_Gift-vouchers-config AND GIFT_MAX_CHARS -> UD-615_Gifts-max-characters
import ClientWithSplitTreatments from 'spa/Components/SplitIo/ClientWithSplitTreatments'; // eslint-disable-line
import SPLIT_TREATMENTS from 'spa/state/SplitTreatmentIdMap'; // eslint-disable-line

const GiftCardBuyStepOne = ({
  clearDefaultTreatment,
  currencySymbol,
  currentStep,
  customAmount,
  defaultTreatment,
  deliveryOption,
  giftAmount,
  giftAmountCustomInvalid,
  giftAmountInvalid,
  giftMessage,
  giftTreatment,
  giftTreatmentInvalid,
  giftType,
  giftUpgrade,
  giftUpgradeInvalid,
  handleGiftUpgrade,
  handleSelectCity,
  handleSelectDeliveryOption,
  selectedCity,
  setCustomAmount,
  setGiftAmount,
  setGiftMessage,
  setGiftTreatment,
  setGiftType,
  setHasGiftUpgradeOptions,
  isReady,
  treatments,
}) => (
  <React.Fragment>
    <GiftsHeader currentStep={currentStep} />
    <GiftsSelectCity
      selectedCity={selectedCity}
      handleSelectCity={handleSelectCity}
    />
    <Divider />
    {(isReady || (process.env && process.env.NODE_ENV === 'test')) ? (
      <React.Fragment>
        {(treatments[SPLIT_TREATMENTS.GIFT_VOUCHERS_CONFIG].treatment === 'on' || (process.env && process.env.NODE_ENV === 'test')) ? (
          <GiftsSelectType
            clearDefaultTreatment={clearDefaultTreatment}
            currencySymbol={currencySymbol}
            customAmount={customAmount}
            defaultTreatment={defaultTreatment}
            giftAmount={giftAmount}
            giftTreatment={giftTreatment}
            giftType={giftType}
            onSetCustomAmount={setCustomAmount}
            onSetGiftAmount={setGiftAmount}
            onSetGiftTreatment={setGiftTreatment}
            onSetGiftType={setGiftType}
            selectedCity={selectedCity}
            giftTreatmentInvalid={giftTreatmentInvalid}
            giftAmountInvalid={giftAmountInvalid}
            giftAmountCustomInvalid={giftAmountCustomInvalid}
          />
        ) : (
          <GiftsSelectTypeOld
            clearDefaultTreatment={clearDefaultTreatment}
            currencySymbol={currencySymbol}
            customAmount={customAmount}
            defaultTreatment={defaultTreatment}
            giftAmount={giftAmount}
            giftTreatment={giftTreatment}
            giftType={giftType}
            onSetCustomAmount={setCustomAmount}
            onSetGiftAmount={setGiftAmount}
            onSetGiftTreatment={setGiftTreatment}
            onSetGiftType={setGiftType}
            selectedCity={selectedCity}
            giftTreatmentInvalid={giftTreatmentInvalid}
            giftAmountInvalid={giftAmountInvalid}
            giftAmountCustomInvalid={giftAmountCustomInvalid}
          />
        )}
      </React.Fragment>
    ) : null}
    {giftType === 'treatment' && (
      <GiftCardUpgrade
        currencySymbol={currencySymbol}
        giftTreatment={giftTreatment}
        selectedCity={selectedCity}
        handleGiftUpgrade={handleGiftUpgrade}
        giftUpgrade={giftUpgrade}
        giftUpgradeInvalid={giftUpgradeInvalid}
        setHasGiftUpgradeOptions={setHasGiftUpgradeOptions}
      />
    )}
    <Divider />
    <GiftsDeliveryOptions
      onSelectDeliveryOption={handleSelectDeliveryOption}
      deliveryOption={deliveryOption}
      currencySymbol={currencySymbol}
    />
    <Divider />
    {(isReady || (process.env && process.env.NODE_ENV === 'test')) ? (
      <React.Fragment>
        {(treatments[SPLIT_TREATMENTS.GIFT_MAX_CHARS].treatment === 'on' || (process.env && process.env.NODE_ENV === 'test')) ? (
          <GiftsMessage giftMessage={giftMessage} onSetGiftMessage={setGiftMessage} />
        ) : (
          <GiftsMessageOld giftMessage={giftMessage} onSetGiftMessage={setGiftMessage} />
        )}
      </React.Fragment>
    ) : null}
  </React.Fragment>
);

GiftCardBuyStepOne.propTypes = {
  handleGiftUpgrade: PropTypes.func.isRequired,
  giftUpgrade: PropTypes.shape({
    description: PropTypes.string,
    isPopular: PropTypes.bool,
    option_id: PropTypes.string,
    upgrade_value: PropTypes.number,
  }),
  clearDefaultTreatment: PropTypes.func.isRequired,
  giftAmountCustomInvalid: PropTypes.bool,
  currencySymbol: PropTypes.string,
  currentStep: PropTypes.number.isRequired,
  customAmount: PropTypes.string,
  defaultTreatment: PropTypes.string,
  deliveryOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    price: PropTypes.number,
  }),
  giftAmount: PropTypes.string,
  giftAmountInvalid: PropTypes.bool,
  giftMessage: PropTypes.string,
  giftTreatment: PropTypes.shape({
    specialityId: PropTypes.string,
    groupIndex: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    price: PropTypes.number,
  }),
  giftTreatmentInvalid: PropTypes.bool,
  giftType: PropTypes.string,
  giftUpgradeInvalid: PropTypes.bool,
  handleSelectCity: PropTypes.func.isRequired,
  handleSelectDeliveryOption: PropTypes.func.isRequired,
  selectedCity: PropTypes.string,
  setCustomAmount: PropTypes.func.isRequired,
  setGiftAmount: PropTypes.func.isRequired,
  setGiftMessage: PropTypes.func.isRequired,
  setGiftTreatment: PropTypes.func.isRequired,
  setGiftType: PropTypes.func.isRequired,
  setHasGiftUpgradeOptions: PropTypes.func.isRequired,
  isReady: PropTypes.bool.isRequired,
  treatments: PropTypes.object.isRequired,
};

export default ClientWithSplitTreatments([SPLIT_TREATMENTS.GIFT_VOUCHERS_CONFIG, SPLIT_TREATMENTS.GIFT_MAX_CHARS])(GiftCardBuyStepOne);



// WEBPACK FOOTER //
// ./spa/Pages/Gifts/GiftCardBuyStepOne.jsx